import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import BuyerSupplierView from '../../components/Customers/BuyerSupplierView'


const CustomerView =() => {
    return(
      <>
        {/* <Breadcrumb /> */}
        <BuyerSupplierView/>
      </>
    );
};
export default CustomerView;